import * as yup from "yup";
import { convertDateToString, convertTimeToString } from "../utility/ConvertUtily";

const now = new Date();
const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
let tempDatetime = new Date();

export type Messages = {
  id: string;
  tenantId: string;
  title: string;
  body: string;
  urlButtonFlg?: boolean;
  urlButtonName?: string;
  urlLink?: string;
  image: string;
  contactInformation?: string;
  eventVenue? : string;
  isMunicipality?: boolean;
  type: string;
  link: string;
  url?: string;
  fileupload: string;
  fileUpload?:string;
  topic?: string[];
  draftFlg: boolean;
  authorUid: string;
  authorName?: string;
  deliveredFlg: boolean;
  eventFlg: boolean;
  eventAt: Date;
  eventAtTime?: string;
  eventEndAt: Date;
  eventEndAtTime?: string;
  isEventTimeEmpty?: boolean;
  eventType?: string;
  publishEndAt?: Date;
  publishEndAtTime?: string;
  sendDate: Date;
  sendDateTime?: string;
  select?: string;
  replyButton?: string;
  createAt: Date;
  deliverList?: string[];
  topicLength?: number;
  tokenLength?: number;
  staffConfirmedFlg?: boolean;
  municipalityConfirmedFlg?: boolean;
  questionnaireFlg: boolean;
  questionnaireSendFlg: boolean;
  pointId?: string;
  pointSettingFlg?: boolean;
  pointTypeId?: string;
  pointTypeName?: string;
  pointName?: string;
  pointAssignmentPoint?: number;
  pointCategoryId?: number;
  pointCategoryName?: string;
  pointAwardedFlg?: boolean;
};

export const newMessage = (): Messages => {
  return  {
    id: "",
    tenantId: "",
    title: "",
    body: "",
    image: "",
    urlButtonName: "",
    urlLink: "",
    contactInformation: "",
    eventVenue: "",
    type: "",
    link: "",
    url: "https://",
    fileupload: "",
    topic: [],
    draftFlg: false,
    authorUid: "",
    deliveredFlg: false,
    eventFlg: false,
    eventAt: nowDate,
    eventEndAt: nowDate,
    eventType: '',
    sendDate: now,
    select: "",
    replyButton: '',
    createAt: now,
    questionnaireFlg: false,
    questionnaireSendFlg: false,
    pointId: "",
    pointSettingFlg: false,
    pointTypeId: "",
    pointTypeName: "",
    pointName: "",
    pointCategoryName: "",
    pointAwardedFlg: false,
  };
};

// お知らせ検索用
export type SearchMessage = {
  title: string;
  contactInformation: string;
  select: string;
  sendDateStart: string;
  sendDateEnd: string;
  publishEndAtStart: string;
  publishEndAtEnd: string;
  eventAtStart: string;
  eventAtEnd: string;
  eventFlg: string;
  status: string;
  replyButton: string;
  eventType: string;
  authorName: string;
  topic: {id: string, title: string}[];
};

// お知らせ検索初期値
export const MessageSearchDefault = (): SearchMessage => {
  return  {
    title: "",
    contactInformation: "",
    select: "",
    sendDateStart: "",
    sendDateEnd: "",
    publishEndAtStart: "",
    publishEndAtEnd: "",
    eventAtStart: "",
    eventAtEnd: "",
    eventFlg: "",
    status: "",
    replyButton: '',
    eventType: '',
    authorName: "",
    topic: [],
  };
};

// お知らせ取得API用データ初期値
export const defaultMessageSearchData = () => {
  return {
    title: null,
    contactInformation: null,
    select: null,
    groupId: null,
    sendAtStart: null,
    sendAtEnd: null,
    publishEndAtStart: null,
    publishEndAtEnd: null,
    eventAtStart: null,
    eventAtEnd: null,
    eventFlg: null,
    status: null,
    replyButtonId: null,
    eventType: null,
    authorName: null
  };
};

// お知らせ取得API用データ作成
export const getMessageSearchData = (data: SearchMessage, checkedValue: string, checkedDate: string) => {
  return {
    title: data.title !== "" && checkedValue === "title" ? data.title : null,
    contactInformation: data.contactInformation !== "" && checkedValue === "contactInformation" ? data.contactInformation : null,
    select: data.select !== "" ? data.select : null,
    groupId: data.select === "topic" ? data.topic.map(t => t.id) : null,
    sendAtStart: data.sendDateStart !== "" && checkedDate === "sendDate" ? new Date(data.sendDateStart + "T00:00:00.000+09:00") : null,
    sendAtEnd: data.sendDateEnd !== "" && checkedDate === "sendDate" ? new Date(data.sendDateEnd + "T23:59:59.000+09:00") : null,
    publishEndAtStart: data.publishEndAtStart !== "" && checkedDate === "publishEndAt" ? new Date(data.publishEndAtStart + "T00:00:00.000+09:00") : null,
    publishEndAtEnd: data.publishEndAtEnd !== "" && checkedDate === "publishEndAt" ? new Date(data.publishEndAtEnd + "T23:59:59.000+09:00") : null,
    eventAtStart: data.eventAtStart !== "" && checkedDate === "eventAt" ? new Date(data.eventAtStart + "T00:00:00.000+09:00") : null,
    eventAtEnd: data.eventAtEnd !== "" && checkedDate === "eventAt" ? new Date(data.eventAtEnd + "T23:59:59.000+09:00") : null,
    eventFlg: data.eventFlg === "message" ? false : data.eventFlg === "schedule" ? true : null,
    status: data.status !== "" ? data.status : null,
    replyButtonId: data.replyButton !== "" ? data.replyButton : null,
    eventType: data.eventType !== "" ? data.eventType : null,
    authorName: data.authorName !== "" ? data.authorName : null
  };
};

// 配信日とイベントのモデル
export type SendDateAndEventDateList = {
  sendDate: Date;
  eventAt?: Date;
  eventEndAt?: Date;
  publishEndAt?: Date;
};

// firestoreから取得したデータのマッピング
export const MessageTimestampToDate = (data: any | undefined): Messages => {
  if(data.eventAt !== undefined && data.eventEndAt !== undefined){
    data.eventAt = new Date(data?.eventAt.seconds * 1000);
    data.eventEndAt = new Date(data?.eventEndAt.seconds * 1000);
  }
  data.sendDate = new Date(data?.sendDate.seconds * 1000);
  data.createAt = new Date(data?.createAt.seconds * 1000);
  if(data?.publishEndAt !== undefined){
    data.publishEndAt = new Date(data?.publishEndAt?.seconds * 1000);
  }
  if(data?.regularSetting !== undefined && data?.regularSetting?.endDate !== undefined){
    data.regularSetting.endDate = new Date(data.regularSetting.endDate * 1000);
  }
  return data;
}

// お知らせ一覧のデータのマッピング
export const MessageListTimestampToDate = (data: any | undefined): Messages => {
  if(data.eventAt !== undefined && data.eventEndAt !== undefined){
    data.eventAt = new Date(data?.eventAt);
    data.eventEndAt = new Date(data?.eventEndAt);
  }
  data.sendDate = new Date(data?.sendDate);
  data.createAt = new Date(data?.createAt);
  if(data?.publishEndAt !== undefined){
    data.publishEndAt = new Date(data?.publishEndAt);
  }
  if(data?.regularSetting !== undefined && data?.regularSetting?.endDate !== undefined){
    data.regularSetting.endDate = new Date(data.regularSetting.endDate );
  }
  return data;
}

// 予定表一覧用モデル
export type EventMessageView = {
  id: string;
  title: string;
  deliveredFlg: boolean;
  draftFlg: boolean;
  publishEndAt: Date | null;
  eventAt: Date;
  eventEndAt: Date;
  publishState: string;
  replyButtonId: string | null;
};

// rdbから取得した予定表一覧のデータのマッピング
export const RdbEventMessageListTimestampToDate = (data: any | undefined): EventMessageView => {
  let messageData: EventMessageView = {
    id: data.id,
    title: data.title,
    deliveredFlg: data.delivered_flg,
    draftFlg: data.draft_flg,
    publishEndAt: data.publish_end_at !== null ? new Date(data.publish_end_at) : null,
    eventAt: new Date(data.event_at),
    eventEndAt: new Date(data.event_end_at),
    publishState: data.publish_state,
    replyButtonId: data.reply_button_id,
  }

  return messageData;
}

// お知らせ一覧用モデル
export type MessageView = {
  id: string;
  title: string;
  deliveredFlg: boolean;
  draftFlg: boolean;
  publishEndAt: Date | null;
  sendDate: Date;
  eventFlg: boolean;
  eventAt: Date | null;
  select: string;
  authorName: string;
  createAt: Date;
  publishState: string;
  publishTarget: string;
  replyButtonId: string | null;
};

// rdbから取得したお知らせ一覧のデータのマッピング
export const RdbMessageListTimestampToDate = (data: any | undefined): MessageView => {
  let messageData: MessageView = {
    id: data.id,
    title: data.title,
    deliveredFlg: data.delivered_flg,
    draftFlg: data.draft_flg,
    publishEndAt: data.publish_end_at !== null ? new Date(data.publish_end_at) : null,
    sendDate: new Date(data.send_date),
    eventFlg: data.event_flg,
    eventAt: data.event_at !== null ? new Date(data.event_at) : null,
    select: data.send_select,
    authorName: data.author_name,
    createAt: new Date(data.create_at),
    publishState: data.publish_state,
    publishTarget: data.publish_target,
    replyButtonId: data.reply_button_id,
  }

  return messageData;
}

// Messagesのサブコレクション（DeliverList）
export type DeliverList = {
  id: string;
  tenantId: string;
  messageId: string;
};

// Messagesのサブコレクション（Topic）
export type Topic = {
  id: string;
  tenantId: string;
  messageId: string;
  draftFlg: boolean;
  deliveredFlg: boolean;
  sendDate: Date;
  eventFlg: boolean;
  eventAt: Date | null;
  updateAt?: Date;
};

// firestoreから取得したtopicデータのマッピング
export const TopicTimestampToDate = (data: any | undefined): Topic => {
  data.sendDate = new Date(data?.sendDate.seconds * 1000);
  if(data?.eventAt !== null){
    data.eventAt = new Date(data?.eventAt.seconds * 1000);
  }
  if(data?.updateAt !== undefined){
    data.updateAt = new Date(data?.updateAt.seconds * 1000);
  }
  return data;
}

//Messageのサブコレクション
export type Token = {
  messageId?: string | null;
  tenantId: string;
  deliveredFlg: boolean;
  sendDate: Date;
  userId: string;
  eventFlg: boolean;
  eventAt: Date;
};

// firestoreから取得したtokenデータのマッピング
export const TokenTimestampToDate = (data: any | undefined): Token => {
  data.sendDate = new Date(data?.sendDate.seconds * 1000);
  return data;
}

// お知らせ配信先一覧
export type MessageDeliver = {
  userId: string;
  lastName: string;
  readed: string;
  account: string;
  replyData: string;
  groups: string[] | null;
};

// rdbから取得したお知らせ配信先一覧のデータのマッピング
export const RdbMessageDeliverMapping = (data: any | undefined): MessageDeliver => {
  const result: MessageDeliver = {
    userId: data.display_id,
    lastName: data.last_name,
    readed: data.readed,
    account: data.account,
    replyData: data.reply_data,
    groups: data.groups
  }

  return result;
}

// 予定表出欠一覧
export type MessageAttendanceList = {
  checkbox: boolean;
  userId: string;
  displayId: string;
  lastName: string;
  readed: boolean | null;
  status: boolean;
  account: string;
  attendanceData: string;
  groups: string[] | null;
};

// RDBお知らせ出欠一覧検索用モデル
export type RdbMessageAttendanceSearch = {
  lastName: string | null;
  readed: string | null;
  status: string | null;
  account: string | null;
  attendanceData:  string[] | null;
  groupId: string[] | null;
};

export const newRdbMessageAttendanceSearch = (): RdbMessageAttendanceSearch => {
  return {
    lastName: null,
    readed: null,
    status: null,
    account: null,
    attendanceData: null,
    groupId: null
  }
}

// rdbから取得した予定表出欠一覧のデータのマッピング
export const RdbMessageAttendanceMapping = (data: any | undefined): MessageAttendanceList => {
  const result: MessageAttendanceList = {
    checkbox: data.confirmation_check,
    userId: data.id,
    displayId: data.display_id,
    lastName: data.last_name,
    readed: data.readed,
    status: data.status,
    account: data.account,
    attendanceData: data.attendance_data,
    groups: data.groups
  }

  return result;
}

/** [from, to) で lower_bound（昇順で最初に入る位置） */
const lowerBoundByUserId = (
  list: MessageAttendanceList[],
  from: number,
  to: number,
  userId: string
) => {
  let lo = from, hi = to;
  const v = Number(userId);
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (v <= Number(list[mid].userId)) hi = mid;
    else lo = mid + 1;
  }
  return lo;
};

/**
 * 以下の条件で item を list に挿入（イミュータブルに新配列を返す）
 * - 全体は 'FALSE' セグメント → 'TRUE' セグメントの順
 * - 各セグメント内は userId 昇順（同値は手前に入る）
 */
export const insertMessageAttendance = (
  list: MessageAttendanceList[],
  item: MessageAttendanceList
): MessageAttendanceList[] => {
  // 'TRUE' が最初に現れる位置（なければ -1）
  const firstTrue = list.findIndex(x => x.status === true);

  if (item.status === false) {
    // FALSE セグメント: [0, firstTrue) ※firstTrue が -1なら全体が FALSE
    const end = firstTrue === -1 ? list.length : firstTrue;
    const idx = lowerBoundByUserId(list, 0, end, item.userId);
    return [...list.slice(0, idx), item, ...list.slice(idx)];
  } else {
    // TRUE セグメント: [firstTrue, list.length) ※firstTrue が -1なら TRUE は末尾挿入開始点が list.length
    const start = firstTrue === -1 ? list.length : firstTrue;
    const idx = lowerBoundByUserId(list, start, list.length, item.userId);
    return [...list.slice(0, idx), item, ...list.slice(idx)];
  }
}

export const messageSchema = yup.object({
  // タイトル
  title: yup.string().label('タイトル').required(),
  // 配信日
  sendDate: yup.date().label('配信日').required().test((value, testContext) => {
    const sendDateValue = testContext.parent.sendDate;
    const now = new Date();
    const nowDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    )
    if(sendDateValue < nowDate){
      return testContext.createError({
        message: `${convertDateToString(new Date(nowDate.setDate(nowDate.getDate() - 1)))}より後でなければなりません。`
      })
    }
    return true;
  }),
  // 配信時間
  sendDateTime: yup.string().label('配信時間').test((value, testContext) => {
    if (value === "") return true;
    const sendAt = testContext.parent.sendDate;
    if (sendAt === undefined) return true;
    const now = new Date();
    const nowDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    )
    const sendAtDate = new Date(
      sendAt.getFullYear(),
      sendAt.getMonth(),
      sendAt.getDate()
    )
    if (sendAtDate.getTime() === nowDate.getTime()) {
      const nowDateTime = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes()
      )
      const sendAtTime = new Date(
        sendAt.getFullYear(),
        sendAt.getMonth(),
        sendAt.getDate(),
        Number(value?.substring(0,2)),
        Number(value?.substring(3))
      )
      if(sendAtTime < nowDateTime){
        return testContext.createError({
          message: `${convertTimeToString(new Date(nowDateTime.setMinutes(nowDateTime.getMinutes() - 1)))}より後でなければなりません。`,
        })
      }
    }
    return true;
  }),
  // 掲載終了日
  publishEndAt: yup.date().label('掲載終了日').test((value, testContext) => {
    const publishEndAtValue = testContext.parent.publishEndAt;
    const eventFlg = testContext.parent.eventFlg;
    const eventAtValue = testContext.parent.eventAt;
    const sendDateValue = testContext.parent.sendDate;
    if(publishEndAtValue !== undefined){
      let comparisonTarget = null;
      const now = new Date();
      const nowDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      )
      const sendDate = new Date(
        sendDateValue.getFullYear(),
        sendDateValue.getMonth(),
        sendDateValue.getDate()
      )
      const eventStartDate = new Date(
        eventAtValue.getFullYear(),
        eventAtValue.getMonth(),
        eventAtValue.getDate()
      )
      if (publishEndAtValue < nowDate) {
        // 掲載終了日が処理日より過去の場合
        comparisonTarget = new Date(nowDate.setDate(nowDate.getDate() - 1));
      } else if (publishEndAtValue < sendDate) {
        // 掲載終了日が配信日より過去の場合
        comparisonTarget = new Date(sendDate.setDate(sendDate.getDate() - 1));
      } else if (eventFlg && publishEndAtValue < eventStartDate) {
        // 掲載終了日がイベント開催日より過去の場合
        comparisonTarget = new Date(eventStartDate.setDate(eventStartDate.getDate() - 1));
      }
      if (comparisonTarget !== null) {
        return testContext.createError({
          message: `${convertDateToString(comparisonTarget)}より後でなければなりません。`
        })
      }
    }
    return true;
  }),
  // 本文
  body: yup.string().label('本文').required(),
  // URLリンクボタン名
  urlButtonName: yup.string().label('URLボタン名')
    .when('urlButtonFlg', {
      is: true,
      then: yup.string().required()
    }),
  // URLリンク
  urlLink: yup.string().label('URL')
    .when('urlButtonFlg', {
      is: true,
      then: yup.string().url().required()
    }),
  // 予定表への記載
  eventFlg: yup.boolean(),
  // 開催日時
  eventAt: yup.date().required().label('イベント開催日').when('eventFlg', {
    is: true,
    then: yup.date().when('sendDate', {
      is: (sendDate: Date) => tempDatetime = sendDate,
      then: yup.date().test((value, testContext) => {
        let comparisonTarget = null;
        const now = new Date();
        const nowDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate()
        )
        const eventAt = testContext.parent.eventAt;
        const eventStartDate = new Date(
          eventAt.getFullYear(),
          eventAt.getMonth(),
          eventAt.getDate()
        )
        const sendDateValue = testContext.parent.sendDate;
        const sendDate = new Date(
          sendDateValue.getFullYear(),
          sendDateValue.getMonth(),
          sendDateValue.getDate()
        )
        if(eventStartDate < nowDate){
          // イベント開催日が処理日より過去の場合
          comparisonTarget = new Date(nowDate.setDate(nowDate.getDate() - 1));
        } else if (eventStartDate < sendDate) {
          // イベント開催日が配信日より過去の場合
          comparisonTarget = new Date(sendDate.setDate(sendDate.getDate() - 1));
        }
        if (comparisonTarget !== null) {
          return testContext.createError({
            message: `${convertDateToString(comparisonTarget)}より後でなければなりません。`
          })
        }
        return true;
      })
    })
  }),
  // 開始時間
  eventAtTime: yup.string().label('開始時間').when('eventFlg', {
    is: true,
    then: yup.string().when('sendDate', {
      is: (sendDate: Date) => tempDatetime = sendDate,
      then: yup.string().required().test((value, testContext) => {
        const tempDatetimeAt = new Date(
          tempDatetime.getFullYear(),
          tempDatetime.getMonth(),
          tempDatetime.getDate()
        )
        const eventAt = testContext.parent.eventAt;
        const eventStartAt = new Date(
          eventAt.getFullYear(),
          eventAt.getMonth(),
          eventAt.getDate()
        )
        const eventStartAtTime = new Date(
          eventAt.getFullYear(),
          eventAt.getMonth(),
          eventAt.getDate(),
          Number(value?.substring(0,2)),
          Number(value?.substring(3))
        )
        let today = new Date();
        const todayAt = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        )
        if (testContext.parent.sendDateTime === '--:--' || testContext.parent.sendDateTime === '') {
          // 時分が未入力の場合
          if (todayAt.toDateString() === eventStartAt.toDateString()){
            // 処理日とイベント開催日が同日の場合
            if(eventStartAtTime <= today){
              // イベント開催開始時間が処理日時以前の場合
              return testContext.createError({
                message: `${convertTimeToString(today)}より後でなければなりません。`,
              })
            }
          }
        } else if (tempDatetimeAt.toDateString() === eventStartAt.toDateString()){
          // 配信日とイベント開催日が同日の場合
          if(eventStartAtTime <= tempDatetime){
            // イベント開催開始時間が配信日時以前の場合
            return testContext.createError({
              message: `${convertTimeToString(tempDatetime)}より後でなければなりません。`,
            })
          }
        }
        return true;
      })
    })
  }),
  // 終了日時
  eventEndAtTime: yup.string().label('終了時間').when('eventFlg', {
    is: true,
    then: yup.string().required().test((value, testContext) => {
      const eventAtTime = testContext.parent.eventAtTime;
      let today = new Date();
      const eventStartAt = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        Number(eventAtTime?.substring(0,2)),
        Number(eventAtTime?.substring(3))
      )
      const eventEndAt = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        Number(value?.substring(0,2)),
        Number(value?.substring(3))
      )
      if(eventStartAt >= eventEndAt){
        return testContext.createError({
          message: `${eventAtTime}より後でなければなりません。`
        })
      }
      return true;
    })
  }),
  // ミーティングURL直接入力
  url: yup.string().when('eventFlg', {
    is: true,
    then: yup.string().when('link', {
      is: (link: string) =>  link === '',
      then: yup.string().url().required()
    })
  }),
  // 返信ボタン
  replyButton: yup.string().when('eventFlg', {
    is: true,
    then: yup.string()
      .label('予定表へ記載する場合、返信ボタン')
      .required().test(
      'replyButton',
      (replyButton, _) => {
        if(replyButton === '' || replyButton === undefined || replyButton === "undefined" || replyButton === 'none'){
          return false;
        }
        return true;
      }
    )
  }),
  select: yup.string().label('配信先').required()
  .test('select', (select, context) => select !== '')
  .when(['topicLength','tokenLength'], {
    is: (topicLength: number,tokenLength: number) => topicLength <=0 ||  tokenLength <=0,
    then: yup.string().required().test((value, testContext) => {
      const select = testContext.parent.select;
      if(select === "topic" && testContext.parent.topicLength <= 0){
        return testContext.createError({
          message: `グループを選択してください`
        })
      }else if(select === "token" && testContext.parent.tokenLength <= 0){
        return testContext.createError({
          message: `利用者を選択してください`
        })
      }else{
        // 全体配信
        return true;
      }
    })
  }),
});
